import type { Template } from "@/types";

export const PO_06_H3_V3: Template[] = [
{
    id: "po-06-h3v3-01",
    name: "PO 01 - H3V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h3_v3_01.png",
    size: [1217, 851],
    style: {},
        slots: [          
            { id: "1", x: 43, y: 180, width: 228, height: 159, rotation: 0, imageRotation: 0 },
            { id: "2", x: 43, y: 347, width: 228, height: 158, rotation: 0, imageRotation: 0 },
            { id: "3", x: 43, y: 513, width: 228, height: 158, rotation: 0, imageRotation: 0 },
            { id: "4", x: 279, y: 180, width: 312, height: 491, rotation: 0, imageRotation: 0 },
            { id: "5", x: 627, y: 211, width: 272, height: 428, rotation: 0, imageRotation: 0 },
            { id: "6", x: 907, y: 211, width: 271, height: 428, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-06-h3v3-02",
    name: "PO 02 - H3V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h3_v3_02.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 49, y: 156, width: 338, height: 540, rotation: 0, imageRotation: 0 },      
        { id: "2", x: 395, y: 156, width: 169, height: 266, rotation: 0, imageRotation: 0 },
        { id: "3", x: 395, y: 430, width: 169, height: 265, rotation: 0, imageRotation: 0 },
        { id: "4", x: 651, y: 156, width: 513, height: 358, rotation: 0, imageRotation: 0 },
        { id: "5", x: 651, y: 522, width: 253, height: 173, rotation: 0, imageRotation: 0 },
        { id: "6", x: 912, y: 522, width: 252, height: 173, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h3v3-03",
    name: "PO 03 - H3V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h3_v3_03.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 48, y: 156, width: 513, height: 358, rotation: 0, imageRotation: 0 },      
        { id: "2", x: 48, y: 522, width: 253, height: 173, rotation: 0, imageRotation: 0 },
        { id: "3", x: 309, y: 522, width: 252, height: 173, rotation: 0, imageRotation: 0 },
        { id: "4", x: 650, y: 156, width: 337, height: 540, rotation: 0, imageRotation: 0 },
        { id: "5", x: 995, y: 156, width: 169, height: 266, rotation: 0, imageRotation: 0 },
        { id: "6", x: 995, y: 430, width: 169, height: 266, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h3v3-04",
    name: "PO 04 - H3V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h3_v3_04.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 38, y: 144, width: 537, height: 375, rotation: 0, imageRotation: 0 },      
        { id: "2", x: 38, y: 527, width: 265, height: 181, rotation: 0, imageRotation: 0 },
        { id: "3", x: 311, y: 527, width: 264, height: 181, rotation: 0, imageRotation: 0 },
        { id: "4", x: 684, y: 190, width: 294, height: 471, rotation: 0, imageRotation: 0 },
        { id: "5", x: 986, y: 190, width: 149, height: 232, rotation: 0, imageRotation: 0 },
        { id: "6", x: 986, y: 430, width: 149, height: 231, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h3v3-05",
    name: "PO 05 - H3V3",
    albumType: "Hr",
    thumbnail: "/thumbnails/PO/po-06-h3_v3_05.png",
    size: [1217, 851],
    style: {},
    slots: [     
        { id: "1", x: 52, y: 81, width: 318, height: 224, rotation: 0, imageRotation: 0 },
        { id: "2", x: 52, y: 313, width: 318, height: 224, rotation: 0, imageRotation: 0 },
        { id: "3", x: 52, y: 545, width: 318, height: 223, rotation: 0, imageRotation: 0 },
        { id: "4", x: 378, y: 81, width: 440, height: 687, rotation: 0, imageRotation: 0 },
        { id: "5", x: 948, y: 81, width: 215, height: 340, rotation: 0, imageRotation: 0 },
        { id: "6", x: 948, y: 429, width: 215, height: 339, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h3v3-06",
    name: "PO 06 - H3V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h3_v3_06.png",
    size: [1217, 851],
    style: {},
    slots: [     
        { id: "1", x: 61, y: 159, width: 391, height: 263, rotation: 0, imageRotation: 0 },
        { id: "2", x: 61, y: 430, width: 391, height: 262, rotation: 0, imageRotation: 0 },
        { id: "3", x: 459, y: 159, width: 115, height: 173, rotation: 0, imageRotation: 0 },
        { id: "4", x: 459, y: 340, width: 115, height: 172, rotation: 0, imageRotation: 0 },
        { id: "5", x: 459, y: 520, width: 115, height: 172, rotation: 0, imageRotation: 0 },
        { id: "6", x: 657, y: 247, width: 512, height: 358, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h3v3-07",
    name: "PO 07 - H3V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h3_v3_07.png",
    size: [1217, 851],
    style: {},
    slots: [      
        { id: "1", x: 47, y: 159, width: 253, height: 406, rotation: 0, imageRotation: 0 },
        { id: "2", x: 308, y: 159, width: 253, height: 406, rotation: 0, imageRotation: 0 },
        { id: "3", x: 47, y: 573, width: 166, height: 119, rotation: 0, imageRotation: 0 },
        { id: "4", x: 221, y: 573, width: 166, height: 119, rotation: 0, imageRotation: 0 },
        { id: "5", x: 395, y: 573, width: 166, height: 119, rotation: 0, imageRotation: 0 },
        { id: "6", x: 742, y: 159, width: 341, height: 533, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h3v3-08",
    name: "PO 08 - H3V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h3_v3_08.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 42, y: 192, width: 309, height: 467, rotation: 0, imageRotation: 0 },
        { id: "2", x: 359, y: 192, width: 309, height: 467, rotation: 0, imageRotation: 0 },
        { id: "3", x: 676, y: 192, width: 309, height: 467, rotation: 0, imageRotation: 0 },
        { id: "4", x: 993, y: 192, width: 186, height: 151, rotation: 0, imageRotation: 0 },
        { id: "5", x: 993, y: 351, width: 186, height: 150, rotation: 0, imageRotation: 0 },
        { id: "6", x: 993, y: 509, width: 186, height: 150, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h3v3-09",
    name: "PO 09 - H3V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h3_v3_09.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 46, y: 244, width: 113, height: 178, rotation: 0, imageRotation: 0 },
        { id: "2", x: 46, y: 430, width: 252, height: 178, rotation: 0, imageRotation: 0 },
        { id: "3", x: 167, y: 244, width: 252, height: 178, rotation: 0, imageRotation: 0 },
        { id: "4", x: 306, y: 430, width: 113, height: 178, rotation: 0, imageRotation: 0 },
        { id: "5", x: 427, y: 244, width: 513, height: 364, rotation: 0, imageRotation: 0 },
        { id: "6", x: 948, y: 244, width: 224, height: 364, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h3v3-10",
    name: "PO 10 - H3V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h3_v3_10.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 231, width: 124, height: 190, rotation: 0, imageRotation: 0 },
        { id: "2", x: 0, y: 429, width: 124, height: 190, rotation: 0, imageRotation: 0 },
        { id: "3", x: 131, y: 231, width: 552, height: 388, rotation: 0, imageRotation: 0 },
        { id: "4", x: 691, y: 231, width: 252, height: 388, rotation: 0, imageRotation: 0 },     
        { id: "5", x: 951, y: 231, width: 265, height: 190, rotation: 0, imageRotation: 0 },
        { id: "6", x: 951, y: 429, width: 265, height: 190, rotation: 0, imageRotation: 0 }
    ],
}
];